import {contentProps} from './content.props'

import * as Types from './types'
import {successGenerate} from "../common"
const INIT_STATE: contentProps = {
  avatars: [],
}

const contentReducer = (state = INIT_STATE, {type, payload}: any) => {
  switch (type) {
    case successGenerate(Types.AVATAR_LIST):
      return {
        ...state,
        avatars: payload.data,
      }
    default:
      return state
  }
}

export {contentReducer}
